module.exports = __webpack_public_path__ + "static/media/Minerva McGonagall 1.22327b32.jpg";